import Vue from "vue";
import VueRouter from "vue-router";
import { Message } from 'element-ui';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/LayoutView.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/AboutView.vue"),
      },
      {
        path: "/aaa",
        name: "aaa",
        component: () => import("../views/AboutView.vue"),
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/DataScreen.vue"),
      },
      {
        path: "/test",
        name: "test",
        component: () => import("../views/TestView.vue"),
      },
      {
        path: "/mapscreen",
        name: "mapscreen",
        component: () => import("../views/MapScreen.vue"),
      },
      {
        path: "/love",
        name: "love",
        component: () => import("../views/LoveView.vue"),
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path !== '/login' && !token) {
    Message.warning('请先登录');
    next('/login');
  } else {
    next();
  }
});

export default router;
